import { AbstractControl, FormArray, FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import Swal, { SweetAlertOptions } from 'sweetalert2';
import { BaseComponent } from "./base.component";
import { formatDate } from 'ngx-bootstrap/chronos';

export abstract class BaseFormComponent<T> extends BaseComponent {

  form: FormGroup;
  global_value: string
  _entity: T;
  _submitting: boolean = false;
  _erros: any;
  dataFinal: string = '';
  actionLabel: string = "Nova";

  constructor(public activatedRoute: ActivatedRoute) {
    super();
    this._entity = this.activatedRoute.snapshot.data['entity'];
  }

  alertConfirmation(data: any = null, msg = 'Tem certeza que deseja excluir?') {
    return new Observable<boolean>((observer) => {
      Swal.fire({
        title: '',
        text: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: 'sw-system',
      } as SweetAlertOptions).then((result) => {
        if (result.isConfirmed) {
          observer.next(true);
        } else {
          observer.next(false);
        }
        observer.complete();
      });
    });
  }

  confirmation(msg = 'Operação realizada com sucesso!', title = 'Sucesso', icon: any = 'success', cancel: boolean = false, customClass: string = 'sw-system-confirm') {
    return new Observable<boolean>((observer) => {
      Swal.fire({
        title: title,
        text: msg,
        icon: icon,
        showCancelButton: cancel,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: customClass,
      } as SweetAlertOptions).then((result) => {
        if (result.isConfirmed) {
          observer.next(true);
        } else {
          observer.next(false);
        }
        observer.complete();
      });
    });
  }

  msgError(erro = null, title = "Erro") {
    Swal.fire({
      title: title,
      text: erro,
      icon: 'error',
      customClass: 'sw-system',
    } as SweetAlertOptions);
  }

  handleError(error) {
    this.msgError(error?.error?.message);
    this.loaded();
  }

  msgSuccess(msg) {
    Swal.fire({
      title: 'Sucesso!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
      customClass: 'sw-system-confirm',
    } as SweetAlertOptions);
  }

  organizaData(data) {

    let regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;

    let isdate = regex.test(data);
    if (isdate) {
      return data
    } else {
      data = new Date(data)
      data = formatDate(data, 'DD/MM/YYYY');
    }

    return data;
  }

  formataValue(value: string) {
    let v: string;
    v = value.replaceAll('.', '');
    v = value.replace(',', '');
    let t = parseFloat(String(Number(v) / 100)).toFixed(2);
    value = String(t).replace('.', ',');
    return value
  }

  converteValue() {
    let tv = Number(this.formataValue(this.form.value.transfer_value).replace('.', '').replace(',', '.'));
    let cv = Number(this.formataValue(this.form.value.counterpart_value).replace('.', '').replace(',', '.'));
    let rv = Number(this.formataValue(this.form.value.authorized_income_value).replace('.', '').replace(',', '.'));
    this.global_value = this.formataValue(String((tv + cv + rv).toFixed(2)).replace('.', ','));
  }

  dataFormValid(inicio: string, final: string): boolean {
    let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    let dataInicio = this.form.get(inicio).value;
    let dataFinal = this.form.get(final).value;
    dataInicio = !formatoDataRegex.test(dataInicio) ? formatDate(dataInicio, 'DD/MM/YYYY') : dataInicio;
    dataFinal = !formatoDataRegex.test(dataFinal) ? formatDate(dataFinal, 'DD/MM/YYYY') : dataFinal;
    dataInicio = new Date(dataInicio.split('/').reverse().join('/')).getTime();
    dataFinal = new Date(dataFinal.split('/').reverse().join('/')).getTime();
    if (dataFinal && dataInicio > dataFinal) {
      this.dataFinal = 'Data da conclusão não pode ser menor que a data de início.';
      return false;
    } else {
      this.dataFinal = '';
    }
    return true;
  }

  fieldMessageRequired(field): boolean {
    return this.form?.get(field).invalid && this.form?.get(field).dirty;
  }

  fieldErros(field) {
    return this.form?.controls[field]?.errors;
  }

  markAsDirtyOld() {
    Object.keys(this.form.controls).forEach(key => this.form.get(key).markAsDirty());
    setTimeout(() => {
      this._scrollToError();
    }, 0)
  }
  markAsDirty() {
    this.markGroupDirty(this.form);

    setTimeout(() => {
      this._scrollToError();
    }, 0);
  }

  private markGroupDirty(control: AbstractControl) {
    if (control instanceof FormGroup) {
      Object.values(control.controls).forEach(ctrl => {
        this.markGroupDirty(ctrl);
      });
    } else if (control instanceof FormArray) {
      control.controls.forEach(ctrl => {
        this.markGroupDirty(ctrl);
      });
    } else {
      control.markAsDirty();
    }
  }

  _scrollToError(): void {
    const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
    this._scrollTo(firstElementWithError);
  }

  _scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  addDays(days: number, date:string): any {
    let dataString = date;

      // Divide a string para obter dia, mês e ano
      let partesData = dataString.split('/');
      let dia = parseInt(partesData[0], 10);
      let mes = parseInt(partesData[1], 10) - 1; // O mês começa do zero no JavaScript
      let ano = parseInt(partesData[2], 10);

      // Cria um objeto de data
      let data = new Date(ano, mes, dia);

      // Adiciona 60 dias à data
      data.setDate(data.getDate() + days);

      // Obtém o novo dia, mês e ano
      let novoDia = data.getDate();
      let novoMes = data.getMonth() + 1; // Ajusta para o formato brasileiro (mês começa de 0)
      let novoAno = data.getFullYear();

      // Formata a data de volta para o formato brasileiro
      let novaDataString = `${novoDia.toString().padStart(2, '0')}/${novoMes.toString().padStart(2, '0')}/${novoAno}`;

      return novaDataString
  }

  verificaFormatoData(data) {
    // Expressão regular para verificar o formato DD/MM/YYYY
    const formatoData = /^\d{2}\/\d{2}\/\d{4}$/;

    // Verifica se a data corresponde ao formato esperado
    if (formatoData.test(data)) {
      return true; // A data está no formato correto
    } else {
      return false; // A data não está no formato correto
    }
  }



  /**
    * #################### ###
    * ## Getters e Setters ##
    * #######################
    */

  get entity(): T {
    return this._entity;
  }

  set entity(_value) {
    this._entity = _value;
  }

}
